import { render, staticRenderFns } from "./ReverseDisplayItem.vue?vue&type=template&id=39d15058&scoped=true"
import script from "./ReverseDisplayItem.vue?vue&type=script&lang=js"
export * from "./ReverseDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./ReverseDisplayItem.vue?vue&type=style&index=0&id=39d15058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d15058",
  null
  
)

export default component.exports